<template>
  <div class="table-container">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span @click="resetSingleSidebarFilter(name)" title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <b-button
        class="btn-create btn--smaller"
        type="button"
        variant="primary"
        size="sm"
        @click="onAdd"
        title="Crea un nuovo modello SMS"
      >
        <base-icon name="circled_plus" width="22" height="22" />
        Crea
      </b-button>
    </actions-toolbar>

    <b-sidebar
      id="sidebar-1"
      :title="computedFilterTitle"
      :backdrop="true"
      width="50dvw"
      shadow
      right
      :visible="open_filter"
      :data-open="open_filter"
      @change="onSidebarFilterChange"
    >
      <template #header="{ hide }">
        <div class="inner-header">
          <div class="inner-header--create">
            <strong class="mr-auto"> Crea un nuovo modello SMS </strong>
            <b-button
              class="btn btn--create btn--smaller"
              type="button"
              variant="primary"
              size="sm"
              @click="onAdd"
              title="Crea un nuovo modello SMS"
            >
              <base-icon name="circled_plus" width="16" height="16" />
              <span>Crea</span>
            </b-button>
          </div>
          <div class="inner-header--info">
            <strong class="mr-auto">
              {{ computedFilterTitle }}
            </strong>
            <button class="close text-dark" @click="hide">
              <b-icon icon="x"></b-icon>
            </button>
          </div>
        </div>
      </template>
      <b-form @submit.prevent="onSearch(filterName)">
        <div class="filter">
          <div class="filter-item">
            <base-select
              name="type"
              label="Tipo"
              v-model="filter.type"
              :options="types"
              :taggable="false"
              :multiple="false"
            />
          </div>
          <div class="filter-item">
            <base-input
              name="title"
              label="Titolo"
              v-model="filter.title"
              placeholder="Inserisci un titolo"
            />
          </div>
        </div>
        <div class="actions-filter-sidebar-wrapper">
          <b-button
            type="submit"
            variant="lisaweb"
            size="sm"
            v-b-toggle:sidebar-1
            >Cerca
          </b-button>
          <b-button
            class="btn--transparent btn-reset"
            type="button"
            size="sm"
            @click="onClearFilter(filterName)"
            >Reset
          </b-button>
        </div>
      </b-form>
    </b-sidebar>
    <sms
      @edit="onEdit"
      @manualFetch="manualFetch"
      :fields="fields"
      :repository="repository"
      :filterName="filterName"
      :performedSearch="computePerformedSearch"
      :filterCount="countActiveFilters"
      :resource="resource"
      @destroy="onDestroy"
      @duplicate="onDuplicate"
      :ref="tableRef"
    ></sms>
    <duplicate-lisacomunica-template-modal
      :id="duplicateModalId"
      :repository="repository"
      :item="selectedTemplate"
      :type-label="typeLabel"
      @duplicated="onDuplicated"
    />
  </div>
</template>

<script>
import LisaComunicaMixin from "@/mixins/LisaComunicaMixin";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import Sms from "@/components/tables/Sms.vue";
import BaseSelect from "@/components/form/BaseSelect";
import BaseInput from "@/components/form/BaseInput";
import { mapActions } from "vuex";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";
import DuplicateLisacomunicaTemplateModal from "@/components/modals/duplicateLisacomunicaTemplateModal";

export default {
  mixins: [CustomFiltersMixin, LisaComunicaMixin, SidebarFilterMixin],
  data() {
    return {
      repository: "sms",
      resource: "sms",
      tableRef: "smsTableRef",
      filterName: "filterSms",
      typeLabel: "Sms",
      duplicateModalId: "duplicateSmsTemplateModal",
      selectedTemplate: {},
      activeFilters: {},
      performedSearch: false,
      filter: this.initFilter(),
      types: [
        { value: "AVV_SCAD", text: "Avvisi scadenza" },
        { value: "MKTG", text: "Marketing" },
        { value: "SOLL", text: "Solleciti" },
        { value: "REN_PRO", text: "Rendiconti" },
      ],
      fields: [
        {
          key: "actions",
          label: "",
        },
        {
          key: "title",
          label: "Titolo",
        },
        {
          key: "type",
          label: "Tipo",
          formatter: (value) => this.getType(value),
        },
        {
          key: "text_content",
          label: "Testo",
        },
      ],
    };
  },
  components: {
    BaseIcon,
    Sms,
    BaseSelect,
    BaseInput,
    DuplicateLisacomunicaTemplateModal,
  },
  computed: {
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  methods: {
    initFilter() {
      let init = {
        type: null,
        title: null,
      };
      return init;
    },
    getType(value) {
      return this.types.find((type) => type.value === value).text;
    },
    onAdd() {
      this.$router.push({ name: `sms.create` });
    },
    onEdit(id, item) {
      this.$router.push({
        name: `sms.edit`,
        params: { id: `${id}`, item: item },
      });
    },
    onDuplicate(item) {
      // oggetto fresco ad ogni apertura: garantisce il prefill anche
      // ri-cliccando "Duplica" sulla stessa riga
      this.selectedTemplate = { id: item.id, title: item.title };
      this.$bvModal.show(this.duplicateModalId);
    },
    onDuplicated() {
      this.$refs[this.tableRef].fetch();
    },
    onDestroy(id) {
      this.delete(id)
        .then(() => {
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Template Sms eliminato con successo`,
          });
          this.$refs[this.tableRef].fetch();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    manualFetch() {
      this.resetAllFilters();
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs[this.tableRef].fetch();
    });
  },
};
</script>
